import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const PrintRoundedGraphic = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 794 112",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 112),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M794 113V0S641.417 11.973 396.897 11.973C152.378 11.973 0 0 0 0v113h794Z"
    })
  });
};

export { PrintRoundedGraphic };
//# sourceMappingURL=rounded.print.js.map
